import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../../i18n';
import {storeInstance} from '@aofl/store/dist/legacy';
import {licenseAssignMode, modals, pages, sdoNs} from '@modules/constants-enumerate';
import {SimpleModal} from '@modules/simple-modal';
import {RosterUtils} from '@modules/roster-utils';

/**
 * @summary Roster
 * @extends {mapStatePropertiesMixin(i18nMixin(AoflElement))}
 */
@customElement('roster-upload-history-list')
class RosterUploadHistoryList extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  @property({type: Array, attribute: false, mapState: `${sdoNs.USER_JOBS}.$filteredRosters`, store: storeInstance})
  filteredRosters = [];

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.successful_roster`, store: storeInstance})
  hasSuccessfulRoster = false;

  @property({type: Array, attribute: false, mapState: `${sdoNs.SESSION}.$myGroups`, store: storeInstance})
  myGroups = [];

  @property({type: Object, mapState: `${sdoNs.SESSION}.group_info`, store: storeInstance})
  groupInfo = {};

  @property({type: Array, attribute: false, mapState: `${sdoNs.USER_JOBS}.rosterJobs`, store: storeInstance})
  rosters = [];

  @property({type: Boolean, attribute: false})
  disableDownloadLink = false;

  /**
   * Creates an instance of RosterUploadHistoryList.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'roster-upload-history-list';

  async download(rosterId) {
    this.disableDownloadLink = {...this.disableDownloadLink, [rosterId]: true};
    await RosterUtils.download(rosterId);
    const disableDownloadLink = {...this.disableDownloadLink};
    delete disableDownloadLink[rosterId];
    this.disableDownloadLink = disableDownloadLink;
  }

  openLicenseModal(e) {
    this.storeInstance.commit({
      namespace: sdoNs.LICENSE_ASSIGN,
      mutationId: 'setData',
      payload: {
        assignMode: licenseAssignMode.SELECTED,
        rosterId: this.rosters[0].id,
        subsetUrl: pages.STUDENT_SEARCH + `?filters.roster_job_id=${this.rosters[0].id}&wizard=true`
      }
    });

    SimpleModal.show(modals.LICENSE_ASSIGN_BULK, {}, e);
  }

  openErrorsModal(roster, e) {
    SimpleModal.show(modals.ROSTER_ERRORS_MODAL, roster, e);
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default RosterUploadHistoryList;
